import React, { Component } from 'react';
import { connect } from 'react-redux'
import { createReviewTicket, createAdminReviewTicket } from '../../store/actions/restaurantActions'

class MessageReview extends Component {

  constructor(props) {
    super(props);
    this.state = {
    message:''
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  reviewMessageConfirmInterruptor =(e)=>{
  	e.preventDefault();
    document.getElementById("reviewMessageConfirm").style.display = "block";
    console.log('REVIEW');
    console.log(this.props.project);
  }

  handleReviewMessageConfirm = (e)=>{
  	e.preventDefault();
  	this.props.createReviewTicket(this.state.message, this.props.project, (messageId)=>{
  	console.log('called back');
  	console.log(messageId);
  	console.log(this.props.project.userId);
  	this.props.createAdminReviewTicket(messageId, this.props.project.userId, this.props.project);
  	});
    document.getElementById("reviewMessageConfirm").style.display = "none";
    document.getElementById("messageModalReview").style.display = "none";
  }


  render() {
  	const { project } = this.props;

  	return (

  		<div className='container'>
  			{project && 
  		<div>
  		  <form className="white" autoComplete="off">
  			<div className="input-field">
            <textarea id="message"  value={this.state.message} onChange={this.handleChange}></textarea>
            <label className='active' htmlFor="message">Message</label>
            <button className="btn pink lighten-1" onClick={this.reviewMessageConfirmInterruptor}>Submit</button>
          	</div>
          </form>
          <div id={"reviewMessageConfirm"} style={{"display":"none"}}>
                <button className="btn pink lighten-1" onClick={this.handleReviewMessageConfirm}>Confirm</button>  
          </div>
        </div>
      		}
  		</div>
  	)
  }


}

const mapStateToProps = (state) => {
  return {
    state
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createReviewTicket: (message, project, callback) => dispatch(createReviewTicket(message, project, callback)),
    createAdminReviewTicket: (messageId, userId, project) => dispatch(createAdminReviewTicket(messageId, userId, project))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageReview)